import template from './template.html'

function ContabilidadReportesexternosInventarioComponent ($q, ContabilidadReportesexternosCatalogosSucursales, ReportesexternosInventariosCsv, $location, $moment) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.buscar = buscar
  $ctrl.procesando = false
  $ctrl.descargar = descargar

  function $onInit () {
    $ctrl.promise = ContabilidadReportesexternosCatalogosSucursales.get()
      .then(function (response) {
        $ctrl.sucursales = response.data
        $ctrl.opciones = {
          sucursales: $ctrl.busqueda.sucursales ? $ctrl.busqueda.sucursales.split(',') : $ctrl.sucursales.map(function (item) {
            return item.id
          }),
          fechaInicial: $ctrl.busqueda.fechaInicial || $moment().subtract(1, 'months').format('DD/MM/YYYY'),
          fechaFinal: $ctrl.busqueda.fechaFinal || new Date(),
        }
      })
  }

  function buscar () {
    if ($ctrl.procesando) return
    $ctrl.procesando = true
    $ctrl.data = null
    $ctrl.form.$setPristine()
    var busqueda = {
      fechaInicial: $ctrl.opciones.fechaInicial.toYMD(),
      fechaFinal: $ctrl.opciones.fechaFinal.toYMD(),
      sucursales: $ctrl.opciones.sucursales.length === $ctrl.sucursales.length ? '' : $ctrl.opciones.sucursales.join(','),
    }
    $location.search(busqueda)
  }

  function descargar () {
    $ctrl.descargando = true
    ReportesexternosInventariosCsv.get($moment($ctrl.busqueda.fechaInicial).format('YYYY-MM-DD'), $moment($ctrl.busqueda.fechaFinal).format('YYYY-MM-DD'), $ctrl.busqueda.sucursales)
      .then(function (response) {
        response.data.save()
      })
      .catch(function (e) {
        console.log(e)
      })
      .finally(function () {
        $ctrl.contador = $ctrl.contador + $ctrl.limite
        $ctrl.descargando = false
      })
  }
}

angular.module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternosInventario', {
    controller: ContabilidadReportesexternosInventarioComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })





// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/inventario/component.js